/*
 * @Author: brucexlliu
 * @Date: 2023-04-20 11:07:23
 * @LastEditors: brucexlliu
 * @LastEditTime: 2023-06-26 20:09:20
 * @Description: 报错中心
 * @FilePath: \wemeet-web-activity\src\components\ErrorCenter\index.tsx
 */
import React from 'react';
import { Icon } from '@tencent/tea-component';
import classNames from 'classnames';
import './index.scss';
import dataReport from '@utils/data-report';

// 错误类型跳转链接
export const ErrorType = (id: string, eventId: string) => {
  const obj: Record<string, string> = {
    error_type_event_special_audience_name_censor_failed: `/events/host/event/${eventId}/members/audience`,
    error_type_start_time_too_early: `/events/host/event/${eventId}/basic`,
    error_type_end_time_too_early: `/events/host/event/${eventId}/basic`,
    error_type_event_title_censor_failed: `/events/host/event/${eventId}/basic`,
    error_type_event_label_censor_failed: `/events/host/event/${eventId}/basic`,
    error_type_event_address_censor_failed: `/events/host/event/${eventId}/basic`,
    error_type_no_scheduler_found: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_time_overlap: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_desc_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_name_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_pic_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_plan_desc_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_plan_title_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_stage_name_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_stage_warm_up_img_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_stage_warm_up_video_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_session_name_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_event_host_name_censor_failed: `/events/host/event/${eventId}/schedule`,
    error_type_ongoing_or_ended_schedule_cannot_be_edited: `/events/host/event/${eventId}/schedule`,
    error_type_schedule_begin_time_too_early: `/events/host/event/${eventId}/schedule`,
    error_type_schedule_time_exceed_event: `/events/host/event/${eventId}/schedule`,
    error_type_schedule_not_in_event: `/events/host/event/${eventId}/schedule`,
    error_type_scheduler_not_edit: `/events/host/event/${eventId}/schedule`,
    error_type_event_guest_name_censor_failed: `/events/host/event/${eventId}/members/guest`,
    error_type_event_guest_avatar_censor_failed: `/events/host/event/${eventId}/members/guest`,
    error_type_event_guest_company_censor_failed: `/events/host/event/${eventId}/members/guest`,
    error_type_event_guest_position_censor_failed: `/events/host/event/${eventId}/members/guest`,
    error_type_event_guest_desc_censor_failed: `/events/host/event/${eventId}/members/guest`,
    error_type_guest_not_edit: `/events/host/event/${eventId}/members/guest`,
    error_type_no_ticket_found: `/events/host/event/${eventId}/registration/tickets`,
    error_type_scheduler_not_replied_by_ticket: `/events/host/event/${eventId}/registration/tickets`,
    error_type_charge_type_and_ticket_conflict: `/events/host/event/${eventId}/registration/tickets`,
    error_type_ticket_name_censor_failed: `/events/host/event/${eventId}/registration/tickets`,
    error_type_ticket_desc_censor_failed: `/events/host/event/${eventId}/registration/tickets`,
    error_type_ticket_not_edit: `/events/host/event/${eventId}/registration/tickets`,
    error_type_registration_page_cover_censor_failed: `/events/host/event/${eventId}/registration/register`,
    error_type_registration_page_title_censor_failed: `/events/host/event/${eventId}/registration/register`,
    error_type_registration_page_body_censor_failed: `/events/host/event/${eventId}/registration/register`,
    error_type_registration_page_pic_censor_failed: `/events/host/event/${eventId}/registration/register`,
    error_type_register_not_edit: `/events/host/event/${eventId}/registration/register`,
    error_type_no_payment_qualification: '/user-center/my-wallet/qualification-apply/prepare',
    error_type_canvas_info_censor_failed: `/canvas/events/host/?event_id=${eventId}`,
  };
  return obj[id] || '';
};

interface Props {
  data: {
    error_type: string;
    msg: string;
    sort?: number;
  }[];
  visible: boolean;
  setVisible: Function;
  handleError: Function;
  isHostOwner?: boolean;
  status?: number;
  errorItemsSort?: number;
}

const ErrorCenter = (props: Props) => {
  const { data, visible, setVisible, handleError, isHostOwner, status, errorItemsSort } = props;
  const payErrorBtntext = isHostOwner ? '前往验证' : '联系创建者';
  let errorText = errorItemsSort !== 2 ? '审核不通过' : '发布失败';
  if (status === 1 && errorText === '审核不通过') {
    errorText = '上架广场审核未通过';
  }

  return (
    <div className={classNames('error-center', { expand: visible })}>
      <div
        className="error-center-title"
        onClick={() => {
          dataReport('e#event_navigation#error_report_sec#click');
          setVisible(!visible);
        }}
      >
        <Icon type="error" />
        <span>{errorText}</span>
        <span className="error-center-title-number">{data?.length || 0}</span>
        <span>项待处理</span>
        <i className={`iconfont icon-${visible ? 'arrow-up' : 'arrow-down'}`} />
      </div>
      {!!visible && (
        <div className="error-center-content">
          {data?.map((item, index) => {
            const txt = item?.sort === 3 ? '知道了' : '处理';
            return (
              <div className="error-center-content-item" key={index}>
                <span>
                  {index + 1}. {item?.msg}
                </span>
                <span
                  className="error-center-content-item-btn"
                  onClick={() => {
                    handleError(item?.error_type, index);
                  }}
                >
                  {item?.error_type === 'error_type_no_payment_qualification'
                    ? payErrorBtntext
                    : txt}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ErrorCenter;
